module.exports = __webpack_public_path__ + "img/SAS_Longsword Ver2.f9c9f1f3.png";